'use es6';

import PropTypes from 'prop-types';
import { getColors } from 'reporting-ui-components/reports/utils/colors/chartColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AreaChartIcon = ({
  colorSeriesType = 'DEFAULT',
  size = 25
}) => {
  const colors = getColors(colorSeriesType, [0, 1, 2]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("svg", {
      width: size,
      height: size,
      viewBox: "0 0 80 80",
      children: [/*#__PURE__*/_jsx("polygon", {
        fill: colors[0],
        points: "0,71.6 28.8,24.9 80,0 80,25.8 29.2,41 "
      }), /*#__PURE__*/_jsx("polygon", {
        fill: colors[1],
        points: "0,76.2 30.2,44.7 80,29.4 80,48 59,49.6 31,56.2 "
      }), /*#__PURE__*/_jsx("polygon", {
        fill: colors[2],
        points: "0,80 32,59.8 59.2,53.6 80,51.4 80,80 "
      })]
    })
  });
};
AreaChartIcon.propTypes = {
  size: PropTypes.number,
  colorSeriesType: PropTypes.string
};
export default AreaChartIcon;